import { render, staticRenderFns } from "./navbar_bottom.vue?vue&type=template&id=f40a8356&"
import script from "./navbar_bottom.vue?vue&type=script&lang=js&"
export * from "./navbar_bottom.vue?vue&type=script&lang=js&"
import style0 from "./navbar_bottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports